import React, { useState, useEffect } from "react";
import ImageViewer from "react-simple-image-viewer";
import "./Gallery.css";

const Gallery = ({ events }) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open the gallery view for a specific event
  const openGallery = (event) => {
    setSelectedEvent(event);
    setIsGalleryOpen(true);
  };

  // Close the gallery view
  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedEvent(null);
  };

  // Open the full-size image viewer
  const openViewer = (index) => {
    setCurrentImageIndex(index);
    setIsViewerOpen(true);
  };

  // Close the full-size image viewer
  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  // Handle Escape key to close views
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        if (isViewerOpen) {
          closeViewer();
        } else if (isGalleryOpen) {
          closeGallery();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isGalleryOpen, isViewerOpen]);

  return (
    <>
      {/* Event Cards */}
      <div className="gallery">
        {!isGalleryOpen &&
          events.map((event, eventIndex) => (
            <div
              key={eventIndex}
              className="gallery-event-card"
              onClick={() => openGallery(event)}
            >
              <div className="gallery-event-collage">
                {event.images.slice(0, 6).map((image, imageIndex) => (
                  <img
                    key={imageIndex}
                    src={image.src}
                    alt={image.alt || `Event ${eventIndex + 1}`}
                    className="gallery-event-thumbnail"
                  />
                ))}
              </div>
              <h3 className="gallery-event-title">{event.title}</h3>
            </div>
          ))}
      </div>

      {/* Gallery View */}
      {isGalleryOpen && selectedEvent && (
        <div className="gallery-grid-overlay">
          <div className="gallery-grid">
            <div className="gallery-grid-header">
              <h2 className="gallery-grid-title">{selectedEvent.title}</h2>
              <button className="gallery-close-grid" onClick={closeGallery}>
                ✕
              </button>
            </div>
            <div className="gallery-grid-images">
              {selectedEvent.images.map((image, imageIndex) => (
                <div key={imageIndex} className="gallery-grid-card">
                  <img
                    src={image.src}
                    alt={image.alt || `Image ${imageIndex + 1}`}
                    className="gallery-grid-thumbnail"
                    onClick={() => openViewer(imageIndex)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Full-Size Image Viewer */}
      {isViewerOpen && selectedEvent && (
        <div className="image-viewer-overlay">
          <ImageViewer
            src={selectedEvent.images.map((img) => img.src)}
            currentIndex={currentImageIndex}
            onClose={closeViewer}
            disableScroll={false}
            closeOnClickOutside={true}
          />
        </div>
      )}
    </>
  );
};

export default Gallery;
